import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_class_input = _resolveComponent("ontos-class-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createBlock(_component_v_form, {
            key: 0,
            ref: "form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ontos_page_header, {
                title: _ctx.$tt('collection-edit')
              }, null, 8, ["title"]),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ontos_class_input, {
                        ref: "input",
                        value: _ctx.ideaOnChange,
                        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ideaOnChange = $event)),
                        ideas: _ctx.workspace.ideas,
                        "fixed-alias": ""
                      }, null, 8, ["value", "ideas"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { "align-self": "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        size: "small",
                        color: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
                        disabled: _ctx.edit.unchanged
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode("mdi-content-save", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$tt('save')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}